__webpack_require__.p = "https://assets.invalid/packs/";